<template>
  <v-row no-gutters>
    <v-col cols="12" md="12" style="margin:auto">
      <v-carousel
        cycle
        hide-delimiters
        class="c-custom--v-window result-top-carousel"
      >
        <template v-slot:prev="{ on, attrs }">
          <v-icon color="black" v-bind="attrs" v-on="on">mdi-chevron-left</v-icon>
        </template>
        <template v-slot:next="{ on, attrs }">
          <v-icon color="black" v-bind="attrs" v-on="on">mdi-chevron-right</v-icon>
        </template>
        <v-carousel-item v-for="image of dailyImageList" :key="image" style="text-align: center">
          <v-img :src="image" contain max-width="100vw"/>
        </v-carousel-item>
      </v-carousel>
    </v-col>
    <v-col cols="12" style="margin:auto" v-if="showAppStatusInfo">
      <AppStatus :appStatus="appEntryStatus"/>
    </v-col>
  </v-row>
</template>

<script>
import GraphqlAPI from '../../utils/GraphqlAPI'
import dayjs from 'dayjs'
const AppStatus = () => import('../app/AppStatus')

const checkAppUserStatusQuery = (campaignId) => `
  query checkAppUserStatus {
    checkAppUserStatus (campaign_id: "${campaignId}")
  }
`
const checkAppUserStatus = async (campaignId) => {
  const { data: { checkAppUserStatus: data } } = await GraphqlAPI(checkAppUserStatusQuery(campaignId))
  return data
}

export default {
  name: 'resultTopicCarousel',
  data () {
    return {
      dailyImageList: [],
      participants: '',
      myRank: '',
      isCampaignPeriod: false,
      showAppStatusInfo: false
    }
  },
  props: ['campaignUser', 'isSelectedWalkingCourse', 'dailyValueList', 'numberOfSteps'],
  components: {
    AppStatus
  },
  computed: {
    campaign () {
      return this.$store.getters.getCampaign
    },
    campaignOption () {
      return this.$store.getters.getCampaignOption
    },
    appEntryStatus () {
      return this.$store.getters.getAppEntryStatus
    }
  },
  async created () {
    if (!this.campaign.id) {
      await this.$store.dispatch('initCampaign')
    }
    if (this.campaign.is_app_challenge && this.$store.getters.getAppEntryStatus === null) {
      this.featchAppEntryStatus()
    }
    // 画像の取得 28日＠3枚=84枚の画像が用意されている前提
    const targetNum = dayjs().diff(dayjs(new Date(this.campaign.site_open)), 'days') + 1
    const showNum = 3
    for (let i = showNum - 1; i >= 0; i--) {
      const imageNum = this.checkImageNum(targetNum * showNum - i)
      this.dailyImageList.push('/image/daily_image/' + imageNum + '_Daily.png')
    }
    this.getCampaignJson()

    // キャンペーン期間中か
    const startDate = dayjs(this.campaign.start, 'YYYY-MM-DD')
    const siteClose = dayjs(this.campaign.site_close, 'YYYY-MM-DD').add(1, 'days')
    this.isCampaignPeriod = dayjs() >= startDate && dayjs() < siteClose

    // アプリチャレンジステータス表示するか
    // キャンセルステータスの場合、コース変更可能期間後は、ここには表示しない
    if (this.campaign.is_app_challenge) {
      const courseDeletableEnd = dayjs(this.campaign.course_deletable_end, 'YYYY-MM-DD').add(1, 'days')
      const isCourseChangeablePeriod = dayjs() < courseDeletableEnd
      this.showAppStatusInfo = this.appEntryStatus && this.appEntryStatus !== 'Unregistered' && !(!isCourseChangeablePeriod && (this.appEntryStatus === 'Canceled' || this.appEntryStatus === 'Expired'))
    }
  },
  methods: {
    // cloudfront→S3からjsonファイルのキャンペーン参加者人数を取得 ※ログイン画面との整合性を合わせるため
    getCampaignJson () {
      const url = process.env.VUE_APP_CAMPAIGNLIST_URL + '/campaign_list.json'
      var xmlHttpRequest = new XMLHttpRequest()
      xmlHttpRequest.open('GET', url, true)
      xmlHttpRequest.responseType = 'json'
      xmlHttpRequest.send(null)
      const me = this
      xmlHttpRequest.onreadystatechange = function () {
        if (this.readyState === 4 && this.status === 200) {
          if (this.response) {
            const campaignList = this.response
            const targetCampaign = campaignList.find(item => item.is_continuity === me.campaign.is_continuity)
            if (targetCampaign) {
              me.participants = targetCampaign.participants
            }
          }
        }
      }
    },
    async featchAppEntryStatus () {
      try {
        const appEntryStatus = await checkAppUserStatus(this.campaign.id)
        this.$store.dispatch('setAppEntryStatus', appEntryStatus)
      } catch (e) {
        this.$log.debug(e)
      }
    },
    checkImageNum (num) {
      // 84の画像をループするため
      if (num > 84) {
        return this.checkImageNum(num - 84)
      }
      return num
    }
  }
}
</script>
<style scoped lang="scss">
.result-top-carousel {
  @media screen and (min-width: 960px) {
    /* pc */
    height: 300px !important;

    .v-image {
      height: 300px !important;
    }
  }
  @media screen and (max-width: 959px) {
    /* sp */
    height: 50vw !important;

    .v-image {
      height: 50vw !important;
    }
  }
}
</style>
